import * as React from 'react'

import Card        from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent/CardContent'
import Typography  from '@material-ui/core/Typography/Typography'

import { Resource }     from '../../api'
import { ActionButton } from '../atoms'

import saveFile from '../../api/utils'

export default ({ url, name }: Resource) => (
  <Card>
    <CardContent>
      <Typography variant={'caption'} noWrap>
        {name}
      </Typography>
    </CardContent>
    <CardActions>
      <a
        target={'_blank'}
        rel={'noopener'}
        onClick = {() => saveFile(url,name)}
        download={name}
      >
        <ActionButton
          actionType={'download'}
          color={'primary'}
          size={'small'}
        />
      </a>
    </CardActions>
  </Card>
)



// WEBPACK FOOTER //
// ./src/components/molecules/Resource.tsx